import React from 'react'
import LobbyDisconnection from '../components/LobbyDisconnection/LobbyDisconnection'
import { Outlet } from 'react-router'

export default function LobbyDisconnectionProvider({ children }) {
    return (
        <>
            <Outlet />
            <LobbyDisconnection />
        </>
    )
}
